<template>
  <v-container  class="mx-2" fluid>
    <v-row align="center">
      <v-col cols="auto">
        <v-breadcrumbs class="pl-0 pt-0" :items="items"></v-breadcrumbs>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="px-5 pb-5" fluid>
          <v-row align="center">
            <v-card-title>
              Ключ
            </v-card-title>
            <v-spacer></v-spacer>
            <v-btn
              v-if="$checkPermission('export_csv_client')"
              color="primary"
              outlined
              class="text-none ma-2"
              dark
              @click.prevent="downloadReport()"
            >
              Скачать отчёт
            </v-btn>
            <v-btn
              color="primary"
              class="text-none ma-2"
              dark
              @click.prevent="editKey(id)"
            >
              Редактировать ключ
            </v-btn>
          </v-row>
          <v-card-text class="py-0 px-1" v-if="Object.keys(this.key).length != 0">
            <p class="mb-1">id: {{ key.id }}</p>
            <p class="mb-1" v-if="key.name">Имя ключа: {{ key.name }}</p>
            <p class="mb-1">Код ключа: {{ key.code }}</p>
            <p class="mb-1" v-if="key.serial_number">Серийный номер: {{ key.serial_number }}</p>
            <p class="mb-1" v-if="key.created_at">Дата и время создания ключа: {{ ruDateFormat(key.created_at) }}</p>
          </v-card-text>
          <template v-if="roleName === 'admin' && key.universal === 1">
            <h1 class="mb-4 mt-2">Отследить открытие ключа в домофонах</h1>
            <v-row>
              <v-col cols="8" sm="5" md="3">
                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  :nudge-right="40"
                  max-width="320px"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="formattedDateRange"
                      label="Промежуток времени"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      outlined
                      dense
                      hide-details
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="selectedDateRange" @click="menu = false" range :max="today">
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="menu = false">
                      Назад
                    </v-btn>
                    <v-btn text color="primary" :disabled="!selectedDateRange[0]" @click="selectedDateRange = []">
                      Сбросить
                    </v-btn>
                    <v-btn text color="primary" @click="menu = false">
                      Выбрать
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>

              <v-col cols="12" sm="6" md="4" class="d-flex align-center">
                <v-btn
                  color="primary"
                  rounded
                  :disabled="!selectedDateRange[1]"
                  @click="openModalAndLoadData"
                >
                  Посмотреть журнал
                </v-btn>
              </v-col>

              <v-dialog v-model="modalVisible" max-width="1000px" content-class="dialog-border-radius">
                <v-card>
                  <v-card-title>
                    <span class="headline">Журнал открытия двери универсальным ключом</span>
                  </v-card-title>
                  <v-card-text>
                    <div>
                      <p class="mb-1" v-if="key.name">Имя ключа: {{ key.name }}</p>
                      <p class="mb-1">Код ключа: {{ key.code }}</p>
                      <p class="font-weight-medium mb-1">
                        Промежуток времени: {{ ruDateFormat(selectedDateRange[0], true) }} - {{ ruDateFormat(selectedDateRange[1], true) }}
                      </p>
                      <p class="font-weight-medium mb-1">Кол-во записей: {{ journalData.count_discoveries }}</p>
                      <p class="font-weight-medium mb-1">Открытых домофонов: {{ journalData.unique_doorphones }}</p>
                      <v-data-table
                        :headers="journalHeaders"
                        :items="journalData.data"
                        dense
                        class="table"
                      >
                        <template v-slot:item.relay="{ item }">
                          <span v-if="item.relay === 1">{{ 'Реле 1'}}</span>
                          <span v-if="item.relay === 2">{{ 'Реле 2'}}</span>
                        </template>
                        <template v-slot:item.doorphone="{ item }">
                          {{ includeDoorphone && item.doorphone ? getDoorphoneAddress(item.doorphone) : item.doorphone_id }}
                        </template>
                        <template v-slot:item.date="{ item }">
                          {{ metDateTime(item.Date, item.Time) }}
                        </template>
                        <template v-slot:item.status="{item}">
                          <span :style="(+item.Status === 0) ? 'color: red;' : 'color:green;'">
                            {{ getJournalStatus(item.Status) }}
                          </span>
                        </template>
                        <template v-slot:item.type="{item}">
                          {{ includeDoorphone ? getJournalType(item.Type) : item.Type }}
                        </template>
                      </v-data-table>
                    </div>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="modalVisible = false">Закрыть</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-row>
            <v-checkbox
              v-model="includeDoorphone"
              label="Показывать информацию о домофонах"
              class="mt-2"
            />
          </template>
          <v-card flat>
            <v-card-title v-if="displayTable">Домофоны</v-card-title>
            <v-data-table
              v-if="displayTable"
              class="table"
              :headers="TableHeaders"
              :items="doorphones"
              :server-items-length="doorphonesPagination ? doorphonesPagination.total : 0"
              :options.sync="doorphonesOptions"
            >
              <template v-slot:item.address="{ item }">
                {{ getDoorphoneAddress(item) }}
              </template>
              <template v-slot:item.management="{ item }">
                {{ getManagementCompany(item) }}
              </template>
              <template v-slot:item.created_at="{ item }">
                {{ ruDateFormat(item.created_at) }}
              </template>
            </v-data-table>
          </v-card>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import ruDateFormatMixin from '@/mixins/ruDateFormat';
import { JOURNAL_STATUS, JOURNAL_TYPES } from '@/components/doorphone/DetailDoorphone/consts';
import { accessKeysListLocation } from '@/components/accessKeys/accessKeysListRoute';

export default {
  name: 'DetailAccessKey',
  mixins: [ruDateFormatMixin],
  props: ['id'],
  data () {
    return {
      menu: false,
      selectedDate: null,
      modalVisible: false,
      includeDoorphone: false,
      journalData: [],
      selectedDateRange: [],
      today: new Date().toISOString().split('T')[0],
      journalHeaders: [
        { text: 'id', value: 'id' },
        { text: 'Домофон', value: 'doorphone', sortable: false },
        { text: 'Тип', value: 'type', sortable: false },
        { text: 'Реле', value: 'relay', sortable: false },
        { text: 'Статус открытия', value: 'status', sortable: false },
        { text: 'Дата и время', value: 'date', sortable: false },
      ],
      TableHeaders: [
        { text: 'id', value: 'id' },
        { text: 'Адрес', value: 'address', sortable: false },
        { text: 'Управляющая компания', value: 'management', sortable: false },
        { text: 'Дата и время привязки ключа', value: 'created_at' },
      ],
      include: ['managementCompany'],
      abonentsLoaded: true,
      doorphonesOptions: {
        page: 1,
        itemsPerPage: 10,
      },
    };
  },
  created () {
    this.getKeyDetail({
      id: this.$route.params.id,
    })
      .then((result) => {
        this.keys = result.data;
        this.loadDoorphones();
      });
  },
  computed: {
    ...mapGetters({
      key: 'Keys/key',
      roleName: 'roleName',
      doorphones: 'Keys/keyDoorphones',
      doorphonesPagination: 'Keys/keyDoorphonesPagination',
    }),
    items () {
      return [
        {
          text: 'Ключи доступа',
          disabled: false,
          to: accessKeysListLocation(this.$route.query),
        },
        {
          text: 'Ключ',
          disabled: true,
          href: '#',
        },
      ];
    },
    displayTable () {
      return this.doorphones && this.doorphones.length > 0;
    },
    formattedDateRange () {
      return this.selectedDateRange.join(' - ');
    },
  },
  watch: {
    doorphonesOptions: {
      handler (newVal, oldVal) {
        if (oldVal && (newVal.page !== oldVal.page || newVal.itemsPerPage !== oldVal.itemsPerPage)) {
          this.loadDoorphones();
        }
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions({
      getKeyDetail: 'Keys/getKeyDetail',
      exportKeyDoorphonesCsv: 'Keys/exportKeyDoorphonesCsv',
      searchByUniversalCode: 'Keys/searchByUniversalCode',
      getKeyDoorphones: 'Keys/getKeyDoorphones',
    }),
    openModalAndLoadData () {
      this.fetchJournalData();
    },
    fetchJournalData () {
      if (!this.selectedDateRange) return;
      const include = this.includeDoorphone ? ['doorphone'] : [];

      this.searchByUniversalCode({
        code: this.key.code,
        date_from: this.selectedDateRange[0],
        date_to: this.selectedDateRange[1],
        include,
      })
        .then(res => {
          this.journalData = res;
          if (this.journalData.data.length) {
            this.modalVisible = true;
          } else {
            this.$flash_danger('Журнал пуст, записей за текущий период не обнаружено.');
          }
        })
        .catch(err => {
          console.error('Ошибка загрузки журнала:', err);
          this.$flash_warning('Ошибка загрузки журнала');
        });
    },
    editKey (id) {
      this.$router.push({
        name: 'EditKey',
        params: { id },
        query: this.$route.query,
      });
    },
    downloadReport () {
      this.exportKeyDoorphonesCsv(this.id)
        .then((response) => {
          const data = new Blob([response], { type: 'application/csv' });
          const a = document.createElement('a');
          a.download = 'keys_doorphones.csv';
          a.href = URL.createObjectURL(data);
          a.click();
        })
        .catch((e) => {
          this.$flash_warning('Ошибка при скачивании отчёта');
        });
    },
    getJournalType (key) {
      return JOURNAL_TYPES[key];
    },
    getJournalStatus (key) {
      return JOURNAL_STATUS[key];
    },
    metDateTime (date, time) {
      const dateTime = date + ' ' + time;
      return this.ruDateFormat(dateTime);
    },
    getDoorphoneAddress (item) {
      let address = item.address;

      if (item.type === 'G') {
        address += ' (калитка)';
      } else if (item.type === 'A') {
        address += ' (доп.вход)';
      }

      if (item.type !== 'G' && item.entrance > 0) {
        address += `, п. ${item.entrance}`;
      }

      return address;
    },
    getManagementCompany (doorphone) {
      return doorphone.management_company ? doorphone.management_company.name : '';
    },
    loadDoorphones () {
      if (!this.id) return;
      const options = {
        page: this.doorphonesOptions.page,
        limit: this.doorphonesOptions.itemsPerPage,
        include: this.include,
      };
      this.getKeyDoorphones({
        id: this.id,
        options,
      })
        .catch(() => {
          this.$flash_warning('Ошибка при загрузке домофонов');
        });
    },
  },
};
</script>

<style>
h1{
  color: #59606A;
  font-family: "SF Pro Display";
  font-size: 21px;
  font-weight: 500;
  line-height: 21px;
}
</style>
